import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Row, Col, Modal, Divider, Button } from 'antd'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import '../../css/regimen.scss'
import { Redirect, useHistory, useLocation } from 'react-router'
import {
  assignDevices,
  getAllDevices,
  assignPlan,
} from '../../store/action/device.action'
import Assigned from './assigned'
import Filter from './device.filter'
import DeviceList from './device.list'
import {
  setNewPatient,
  addCustomPatient,
} from '../../store/action/patient.action'
import { constants } from '../../constants'
import _, { isEmpty } from 'lodash'

const CarePlans = (props) => {
  var location = useLocation()
  var history = useHistory()

  useEffect(() => {
    props.assignPlan({})
    props.assignDevices([])
    props.getAllDevices(location.state?.patient)
    props.setNewPatient(location.state?.patient)
    //  props.assignDevices(location.state?.devices)
    //  location.state?.devices ? props.assignRegimens(location.state.regimens) : props.autoAssignRegimens(location.state.patient);
    console.log(props, '**************************state_from device form')
  }, [])

  const PatientCreatedBox = (devlen) => {
    Modal.confirm({
      title:
        devlen > 0 ? (
          <div>
            <b>{`${devlen} devices ordered for the new patient ${_.upperFirst(props.newPatient?.firstname)} ${_.upperFirst(props.newPatient?.lastname)}. `}</b>
          </div>
        ) : (
          'Patient created Successfully'
        ),
      icon: <ExclamationCircleOutlined />,
      content: devlen > 0 ? constants.MESSAGE.ORDER_PLACED : '',
      okText: 'Ok',
      cancelButtonProps: { hidden: 'true' },
    })
  }
  var showConfirmBox = () => {
    Modal.confirm({
      title: 'Are you sure you want to leave this page?',
      icon: <ExclamationCircleOutlined />,
      content: 'Your changes will be lost if you go back.',
      okText: 'Yes',
      cancelText: 'No',
      onOk: handleBack,
    })
  }

  var selectDeviceBox = () => {
    Modal.confirm({
      title: 'No Care Plan selected',
      icon: <ExclamationCircleOutlined />,
      content: 'Select a careplan to continue',
      okText: 'Ok',
      cancelButtonProps: { hidden: 'true' },
    })
  }
  var check = (length, regim, plan) => {
    return length == 0 && !regim && plan != 0
  }

  var handleBack = () => {
    props.assignPlan({})
    props.assignDevices([])
    history.push({
      pathname: '/patient/add/info',
      state: { patient: props.newPatient },
    })
  }

  var handleNext = async () => {
    if (Object.keys(props.plan).length == 0) selectDeviceBox()
    else if (props.assignedDevices.length != 0) {
      history.push({
        pathname: '/patient/add/devices',
        state: {
          patient: props.newPatient,
          devices: props.devices,
          assignedPlan: props.plan,
          assignedDevices: props.assignedDevices,
        },
      })
    } else if (props.plan.include_regimens) {
      history.push({
        pathname: '/patient/add/regimens',
        state: {
          patient: props.newPatient,
          plan: props.plan,
        },
      })
    } else {
      try {
        var response = await props.addPatient(
          {
            ...props.newPatient,
            careplan: props.plan._id,
            include_regimens: props.plan.include_regimens,
          },
          [],
          []
        )

        if (response) {
          PatientCreatedBox(props.assignedDevices?.length)
          history.push('/patient')
        }
      } catch (err) {
        console.log(err)
        alert('Something went wrong')
      }
    }
  }

  return (
    <>
      {!location.state?.patient?.age && <Redirect to='/patient/add/info' />}
      <Row align='middle' className='headerRow divide regHeaderCont'>
        <Col className='headerText regHeader'>
          SELECT CARE PLAN(
          {props.newPatient?.firstname + ' ' + props.newPatient?.lastname})
        </Col>
      </Row>
      <Row className='regContainer'>
        <Col flex={'auto'} className='formBody'>
          <DeviceList />
        </Col>
        <Col id={'selectedplanpreview'} flex={'300px'} className='assignCol'>
          <Assigned />
        </Col>
      </Row>
      <Divider style={{ marginTop: 0 }} />
      <Row gutter={10} justify='end'>
        <Col>
          <Button onClick={showConfirmBox} className={'nextBtn'}>
            BACK
          </Button>
        </Col>
        <Col>
          <Button
            id={'gotoschedule'}
            onClick={handleNext}
            className={'nextBtn'}
          >
            {check(
              props.assignedDevices?.length,
              props.plan?.include_regimens,
              Object.keys(props.plan || {}).length
            )
              ? 'CREATE'
              : 'NEXT'}
          </Button>
        </Col>
      </Row>
    </>
  )
}

CarePlans.propTypes = {
  company: PropTypes.object,
  newPatient: PropTypes.object,
  devices: PropTypes.array,
  plan: PropTypes.object,
  assignedDevices: PropTypes.array,
}

const mapStateToProps = (state) => {
  return {
    company: state.profile.company,
    newPatient: state.patient.newpatient,
    devices: state.device.devices,
    plan: state.device.assignedPlan,
    assignedDevices: state.device.assignedDevices,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setNewPatient: (patient) => dispatch(setNewPatient(patient)),
    assignDevices: (devices) => dispatch(assignDevices(devices)),
    addPatient: (patient, devices, exercises) =>
      dispatch(addCustomPatient({ patient, devices, exercises })),
    assignPlan: (plan) => dispatch(assignPlan(plan)),
    getAllDevices: (patient) =>
      dispatch(
        getAllDevices({
          age_group: patient.age,
          surgery_type: patient.surgery.type,
          gender: patient.gender,
        })
      ),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CarePlans)
